if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.slides = [];
        this.currentIndex = 0;

        const dialog = this.querySelector('.product-media-modal__dialog');
        if (dialog) {
          dialog.addEventListener('pointerup', (e) => e.stopPropagation());
          dialog.addEventListener('click', (e) => {
            if (!e.target.closest('.product-media-modal__close')) e.stopPropagation();
          });
        }
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.slides = Array.from(this.querySelectorAll('.product-media-modal__slide'));
        this.counter = this.querySelector('.product-media-modal__counter-current');
        this.prevBtn = this.querySelector('.product-media-modal__arrow--prev');
        this.nextBtn = this.querySelector('.product-media-modal__arrow--next');

        this.showActiveMedia();
        this.bindArrows();
        this.bindKeyboard();
        this.bindSwipe();
      }

      showActiveMedia() {
        const openedMediaId = this.openedBy?.getAttribute('data-media-id');
        this.currentIndex = 0;

        if (openedMediaId) {
          for (let i = 0; i < this.slides.length; i++) {
            const slideId = this.slides[i].getAttribute('data-media-id');
            if (slideId === openedMediaId || slideId?.endsWith(`-${openedMediaId}`)) {
              this.currentIndex = i;
              break;
            }
          }
        }

        this.goTo(this.currentIndex);
      }

      /**
       * Slajdy są display:none — lazy img się nie ładują. Wymuszamy ładowanie bieżącego + sąsiadów.
       */
      preloadSlideMedia(centerIndex) {
        if (!this.slides?.length) return;
        const offsets = [-2, -1, 0, 1, 2];
        offsets.forEach((off) => {
          const i = centerIndex + off;
          if (i < 0 || i >= this.slides.length) return;
          const slide = this.slides[i];
          if (slide.dataset.mediaPreloaded === 'true') return;
          slide.dataset.mediaPreloaded = 'true';

          slide.querySelectorAll('img').forEach((img) => {
            img.loading = 'eager';
            if (!img.complete) {
              const hint = img.currentSrc || img.getAttribute('src');
              if (hint) {
                const pre = new Image();
                pre.src = hint;
              }
              if (img.decode) img.decode().catch(() => {});
            }
          });
        });
      }

      goTo(index) {
        if (index < 0) index = this.slides.length - 1;
        if (index >= this.slides.length) index = 0;
        this.currentIndex = index;

        this.slides.forEach((slide) => slide.classList.remove('active'));
        const activeSlide = this.slides[this.currentIndex];
        if (activeSlide) {
          activeSlide.classList.add('active');

          const deferred = activeSlide.querySelector('deferred-media, product-model');
          if (deferred && deferred.querySelector('template') && deferred.loadContent) {
            deferred.loadContent(false);
          }
        }

        if (this.counter) {
          this.counter.textContent = this.currentIndex + 1;
        }

        this.preloadSlideMedia(this.currentIndex);
      }

      bindArrows() {
        if (this._arrowsBound) return;
        this._arrowsBound = true;

        if (this.prevBtn) {
          this.prevBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            this.goTo(this.currentIndex - 1);
          });
        }
        if (this.nextBtn) {
          this.nextBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            this.goTo(this.currentIndex + 1);
          });
        }
      }

      bindKeyboard() {
        if (this._keyboardBound) return;
        this._keyboardBound = true;

        this.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') {
            e.preventDefault();
            this.goTo(this.currentIndex - 1);
          } else if (e.key === 'ArrowRight') {
            e.preventDefault();
            this.goTo(this.currentIndex + 1);
          }
        });
      }

      bindSwipe() {
        if (this._swipeBound) return;
        this._swipeBound = true;

        const slider = this.querySelector('.product-media-modal__slider');
        if (!slider) return;

        let startX = 0;
        let startY = 0;
        let moved = false;

        slider.addEventListener('touchstart', (e) => {
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
          moved = false;
        }, { passive: true });

        slider.addEventListener('touchmove', () => {
          moved = true;
        }, { passive: true });

        slider.addEventListener('touchend', (e) => {
          if (!moved) return;
          const diffX = e.changedTouches[0].clientX - startX;
          const diffY = e.changedTouches[0].clientY - startY;
          if (Math.abs(diffX) < 40 || Math.abs(diffX) < Math.abs(diffY)) return;

          if (diffX < 0) {
            this.goTo(this.currentIndex + 1);
          } else {
            this.goTo(this.currentIndex - 1);
          }
        }, { passive: true });
      }
    }
  );
}
